/**
 * LoadingScreen Component
 */
import React from 'react';
import { useI18n } from '@/hooks/useI18n';

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ message }) => {
  const { t } = useI18n();
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-spinner"></div>
        <p className="loading-message">{message || t('common.status.loading')}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;